import React from "react";

const BakeryItemIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enableBackground="new 0 0 20 20"
    height="128px"
    viewBox="0 0 20 20"
    width="128px"
    fill="#000000"
  >
    <g>
      <rect fill="none" height="20" width="20" />
    </g>
    <g>
      <g>
        <path d="M17.99,8c0.26-2.73-3.42-5-7.99-5C5.44,3,1.76,5.27,2.01,8H17.99z M10,4.5c2.5,0,4.83,0.78,5.94,2H4.07 C5.18,5.29,7.51,4.5,10,4.5z" />
        <path d="M2,15.5C2,16.33,2.67,17,3.5,17h13c0.83,0,1.5-0.67,1.5-1.5V13H2V15.5z M3.5,14.5h13v1h-13V14.5z" />
        <path d="M18,11.75c-1.58,0-1.72-1-2.66-1c-0.95,0-1.08,1-2.67,1c-1.58,0-1.72-1-2.67-1c-0.95,0-1.08,1-2.67,1 c-1.58,0-1.72-1-2.67-1c-0.95,0-1.09,1-2.67,1v-1.5c0.95,0,1.09-1,2.67-1c1.58,0,1.72,1,2.67,1c0.95,0,1.08-1,2.67-1 c1.58,0,1.72,1,2.67,1c0.95,0,1.08-1,2.67-1c1.58,0,1.72,1,2.66,1V11.75z" />
      </g>
    </g>
  </svg>
);

export default BakeryItemIcon;
